<ng-template [ngIf]="disabled">
    <input type="text" class="form-control" [value]="condicaoPagamento?.nome | uppercase" disabled="disabled" readonly="readonly">
</ng-template>

<ng-template [ngIf]="!disabled">
    <select 
        #select
        class="form-control" 
        [name]="name"
        [id]="id"
        [required]="required"
        [autofocus]="autofocus"
        [ngModel]="ngModel || ''" 
        (ngModelChange)="onChange($event ? $event : null)">
        <option value="" *ngIf="canSelectNull || (required && !ngModel)">
            {{nullLabel}}
        </option>
        <option *ngFor="let condicaoPagamento of condicoesPagamentos" [ngValue]="condicaoPagamento.id" [disabled]="isSituacaoInativa(condicaoPagamento.situacao)">{{condicaoPagamento.nome | uppercase}}</option>
    </select>  
</ng-template>